module.exports = __webpack_public_path__ + "static/media/25586840_1703512449723939_4519641670928370351_o.0ee63d8f.jpg";